globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.TableSeeMore = (function() {

    function TableSeeMore($html) {
        this.$html = $html;
        this.init();
    }

    TableSeeMore.init = function($html) {
        $html.find('.table.table-see-more').each(function(){
            new TableSeeMore($(this));
        })
    }

    TableSeeMore.prototype = {
        init: function() {
          var $table = this.$html;

          $table.find('tr.show-items').on('click', function() {
            var $this   = $(this),
                offset  = parseInt($(this).data('items-offset')),
                $hidden = $this.siblings('tr:hidden'),
                $shown  = $this.siblings('tr.shown'),
                texts   = {
                  more: "Voir plus",
                  less: "Voir moins",
                  all: "Voir tout"
                },
                totalHidden = $hidden.length;

            if(totalHidden > 0) {
              if(!$this.data('no-more-items')) $hidden = $hidden.slice(0, offset);
              $hidden.show().addClass('shown');
              if(totalHidden > offset) {
                text = $this.data('no-more-items') ? texts.less : texts.more;
              } else {
                $this.data('no-more-items', true);
                text = texts.less;
              }
            } else {
              $shown.hide().removeClass('shown');
              text = texts.all;
            }

            $this.find('td a').text(text);
          });
        }
    }

    return TableSeeMore;

})();
